import angular from 'angular';
import BoxProductsMiniComponent from './box-products-mini.component';

let BoxProductsMiniModule = angular.module('catalog.productsModules.boxProductsMini', [])
  .component('boxProductsMini', BoxProductsMiniComponent);

export default BoxProductsMiniModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/box-products-mini/box-products-mini.js
 **/